module.exports = __webpack_public_path__ + "static/media/thumbnail.41f7fff8.jpg";